export const colors = {
	primary: '#3E84D1',
	secondary: '#66E57C',
	indicatorNumber: '#133864',
	h1: '#133864',
	text: '#404040'
}
